import { Alert, Button, Checkbox, Modal, Space } from "antd"
import { IEvent } from "../types"
import { useTranslation } from "react-i18next"
import { useEffect, useState } from "react"
import { useUnsubscribeFromEvents } from "../queries"
import { useMemberId } from "pages/member"

interface Props {
  open: (data?: IEvent | undefined) => void
  onClose: () => void
  isOpen: boolean
  data?: IEvent | undefined
}

const UnsubscribeModal: React.FC<Props> = ({ data, ...props }) => {
  const { t } = useTranslation("translation")
  const memberId = useMemberId()
  const [applySimilarEvent, setApplySimilarEvent] = useState<boolean>(
    data?.enrollment === "activity"
  )
  useEffect(() => {
    setApplySimilarEvent(data?.enrollment === "activity")
  }, [data?.enrollment])
  const onCheckBoxChange = () => {
    setApplySimilarEvent((old) => !old)
  }

  const { isLoading, mutate } = useUnsubscribeFromEvents(memberId!, {
    meta: {
      type: "unsubscribe",
      context: "male",
      count: 1,
      entity: t("members.member"),
    },
  })

  const onUnsubscribe = () => {
    mutate(
      {
        event_id: data?.id!,
        unassign_from_similar_events: applySimilarEvent,
      },
      {
        onSettled() {
          props.onClose()
        },
        onSuccess() {
          props.onClose()
        },
      }
    )
  }
  return (
    <Modal
      centered
      width={1000}
      title={t("events.unsubscribeX", {
        entity: t("members.member"),
        context: "male",
        count: 1,
      })}
      open={props.isOpen}
      onCancel={props.onClose}
      footer={[
        <Button key="cancel" onClick={props.onClose} type="primary">
          {t("global.cancel")}
        </Button>,
        <Button
          onClick={onUnsubscribe}
          loading={isLoading}
          type="primary"
          key="unsubscribe"
          danger
        >
          {t("events.unsubscribe")}
        </Button>,
      ]}
      key={data?.id}
    >
      <Space direction="vertical">
        <Alert
          message={t("events.unsubscribe_member", {
            entity: data?.name,
          })}
          description={t(
            `events.${
              data?.enrollment === "activity"
                ? "unsubscribe_activity"
                : "unsubscribe_event"
            }`,
            {
              entity: data?.name,
            }
          )}
          type="info"
          showIcon
        />
        {data?.enrollment === "event" && (
          <Checkbox checked={applySimilarEvent} onChange={onCheckBoxChange}>
            {t("events.apply_all_activity_events")}
          </Checkbox>
        )}
      </Space>
    </Modal>
  )
}

export default UnsubscribeModal
